export default function ChevronArrow() {
  return <span className='spinner'></span>;
}
